import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { AuthApi } from "../domain/api/auth.api";
import { Bootstrap } from "../domain/service/bootstrap/bootstrap";

@Component({
	selector: "app-root",
	imports: [CommonModule, RouterOutlet],
	template: ` <router-outlet></router-outlet>
  `,
	styles: [],
})
export class AppComponent implements OnInit {
	constructor(
		private readonly bootstrap: Bootstrap,
		private readonly authApi: AuthApi,
	) {}

	ngOnInit(): void {
		this.bootstrap.bootstrap(this.authApi);
	}

	isCollapsed = false;
}
